import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["tabindex", "onKeydown"]
const _hoisted_2 = ["inputmode", "placeholder", "onKeydown"]

import { computed, nextTick, ref } from 'vue'

/* 계약서 빈칸 — 평소에는 문서 텍스트, 누르면 그 자리에서 입력 */

export default /*@__PURE__*/_defineComponent({
  __name: 'ScEditText',
  props: {
    modelValue: {},
    width: { default: 8 },
    disabled: { type: Boolean, default: false },
    numeric: { type: Boolean, default: false },
    placeholder: { default: '' }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const active = ref(false)
const draft = ref('')
const inputEl = ref<HTMLInputElement | null>(null)

const isBlank = computed(() => !String(props.modelValue || '').trim())

const display = computed(() => {
  const t = String(props.modelValue || '').trim()
  if (t) return t
  return '　'.repeat(Math.min(props.width, 8))
})

const inputWidth = computed(() => `${Math.max(6, draft.value.length + 2)}ch`)

function activate() {
  if (props.disabled) return
  draft.value = String(props.modelValue || '')
  active.value = true
  nextTick(() => inputEl.value?.focus())
}

function commit() {
  if (!active.value) return
  active.value = false
  const v = draft.value.trim()
  if (v !== String(props.modelValue || '')) emit('update:modelValue', v)
}

function cancel() {
  active.value = false
}

return (_ctx: any,_cache: any) => {
  return (!active.value)
    ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: _normalizeClass(["sc__val sc-edit", { 'is-disabled': __props.disabled, 'is-blank': isBlank.value }]),
        role: "button",
        tabindex: __props.disabled ? -1 : 0,
        onClick: activate,
        onKeydown: _withKeys(_withModifiers(activate, ["prevent"]), ["enter"])
      }, _toDisplayString(display.value), 43, _hoisted_1))
    : _withDirectives((_openBlock(), _createElementBlock("input", {
        key: 1,
        ref_key: "inputEl",
        ref: inputEl,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((draft).value = $event)),
        class: "sc-edit-input",
        style: _normalizeStyle({ width: inputWidth.value }),
        inputmode: __props.numeric ? 'numeric' : undefined,
        placeholder: __props.placeholder,
        onBlur: commit,
        onKeydown: [
          _withKeys(_withModifiers(commit, ["prevent"]), ["enter"]),
          _withKeys(_withModifiers(cancel, ["prevent"]), ["esc"])
        ]
      }, null, 44, _hoisted_2)), [
        [_vModelText, draft.value]
      ])
}
}

})